import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { client } from "../../helpers/api/apiCall";

const initialState = {
  sureler: {
    items: [],
    index: 0,
    size: 10,
    count: 0,
    pages: 0,
    hasPrevious: false,
    hasNext: false,
  },
  loading: true,
};

export const getSureler = createAsyncThunk("getSureler", async (body) => {
  const response = await client.post("https://servis.kuranhayatim.com/api/Sure/GetList",body);
  return response.data;
});

export const insertSure = createAsyncThunk("insertSure", async (body,thunkAPI) => {
  const response = await client.post("https://servis.kuranhayatim.com/api/Sure", body,{
    token: thunkAPI.getState().auth.accessToken.token
  });
  return response.data;
});

export const updateSure = createAsyncThunk("updateSure", async (body,thunkAPI) => {
  const response = await client.put("https://servis.kuranhayatim.com/api/Sure", body,{
    token: thunkAPI.getState().auth.accessToken.token
  });
  return response.data;
});

export const deleteSure = createAsyncThunk("deleteSure", async (body,thunkAPI) => {
  const response = await client.delete("https://servis.kuranhayatim.com/api/Sure", body,{
    token: thunkAPI.getState().auth.accessToken.token
  });
  return response.data;
});

const sureSlice = createSlice({
  name: "sure",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getSureler.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getSureler.fulfilled, (state, action) => {
      state.sureler = action.payload;
      state.loading = false;
    });
    builder.addCase(getSureler.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(insertSure.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(insertSure.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(insertSure.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(updateSure.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(updateSure.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(updateSure.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(deleteSure.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(deleteSure.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(deleteSure.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export default sureSlice.reducer;
